import { ErrorBoundary } from "react-error-boundary";
import { useEffect } from "react";
import App from "@/App";
import type { RouteObject } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import CoumstFallbackComponent from "./CoumstFallbackComponent";
import { useAppSelector } from "@/store";

export default function ErrorBoundaryLayout({
  router,
}: {
  router: RouteObject[];
}) {
  const navigation = useNavigate();
  const { pathname } = useLocation();
  const menus = useAppSelector((state) => state.app.menus);
  useEffect(() => {
    if (
      pathname === "/" &&
      menus &&
      menus?.routes &&
      menus?.routes.length > 0 &&
      menus?.routes[0].path
    ) {
      navigation(menus?.routes[0].path, { replace: true });
    }
  }, [navigation, router, pathname, menus]);
  return (
    <ErrorBoundary FallbackComponent={CoumstFallbackComponent}>
      <App />
    </ErrorBoundary>
  );
}
